'use client';

import { ContentOutageNotice } from '@/components/ContentOutageNotice';

/**
 * Segment boundary for the Mongo-backed changelog pages.
 *
 * Without it these fell through to the root `app/error.tsx`, which is written
 * for a signed-in user hitting a bug — wrong copy, and a Contact Support link,
 * for a reader caught by a transient database outage (RELM-350).
 */
export default function ChangelogError({ reset }: { reset: () => void }) {
  return (
    <ContentOutageNotice
      what="update"
      indexHref="/changelog"
      indexLabel="See all updates"
      reset={reset}
    />
  );
}
